<script>
  import { onMount } from 'svelte';
  import { show_message } from '../../lib/flash.ts';
  import DonateMachine from '../donate-machine.js';
  import ConfirmDialog from '../../lib/workpilots-ui/ConfirmDialog.svelte';
  import InputWithValidation from '../../lib/components/InputField.svelte';
  import TextField from '../../lib/components/TextField.svelte';
  import {t9n} from '../../lib/translate';
  import { TS } from '../../config/translation-keys.js';

  export let id;
  export let main;
  export let context;

  let wait_api = false;
  let value_field;
  let machine = new DonateMachine({ id, main, context });
  context = machine.context;

  $: {
    machine.update_context(context);
    context = machine.context;
  }
  const reset_state = () => {
    machine.reset_state();
    context = machine.context;
  };

  const validate = () => {
    machine.validate();
    context = machine.context;
  };

  const donate_pilotpoints = async e => {
    wait_api = true;
    let result = await machine.donate();
    wait_api = false;
    if (!!result) show_message(result.message, result.type);
    reset_state();
  };

  const show_donation_intent = async () => {
    validate();

    if (context.valid) {
      context.show_confirm = true;
    }

    if (!context.show_confirm) {
      await process_confirmed();
    }
  };

  const process_confirmed = async () => {
    context.show_confirm = false;
    context.confirmed = true;

    if (context.valid && context.confirmed) {
      await donate_pilotpoints();
    } else {
      context.show_error = true;
    }
  };

  const init = () => {
    reset_state();
    // value_field.focus();
  };

  onMount(init);

  // TODO: validation
</script>

<div>
  <div class="content">
    <div class="fade-in">
      <InputWithValidation
        bind:this={value_field}
        bind:value={context.donate_amount}
        on:input={validate}
        id="donate-description"
        type="text"
        label={context.donate_amount_label}
        name="donate_amount"
        validate={false}
        is_required={true}
        validation_text={context.errors.donate_amount}
        valid={!context.errors.donate_amount}
        is_tooltip_default={true}
        tooltip_default_text="{context.explanation_1}
        {context.explanation_2}
        {context.explanation_3}"
        width="410px" />

      <span
        class="total"
        class:hidden={context.donate_amount_errors || !context.donate_amount}>
        {context.donation_total_text}
      </span>

      <!-- todo: is error validation needed for textarea? {context.comment_errors} -->
      <div style="margin-top: -6px;">
        <TextField
          bind:value={context.comment}
          label={context.leave_comment_label}
          max_chars={500}
          on:change={validate}
          placeholder={context.comment_label}
          width="410px" />
      </div>

      <div style="margin-top: 15px;" />
      <InputWithValidation
        bind:this={value_field}
        bind:value={context.email}
        on:input={validate}
        id="donate_email"
        type="text"
        label={context.send_to_label}
        name="donate_email"
        validate={false}
        validation_text={context.errors.email}
        valid={!context.errors.email}
        is_required={true}
        is_tooltip_default={false}
        tooltip_default_text="{context.explanation_1}
        {context.explanation_2}
        {context.explanation_3}"
        width="410px" />

      <InputWithValidation
        bind:this={value_field}
        bind:value={context.email_confirm}
        on:input={validate}
        id="donate_email2"
        type="text"
        label={context.confirm_email_label}
        name="donate_email2"
        validate={false}
        validation_text={context.errors.email_confirm}
        valid={!context.errors.email_confirm}
        is_required={true}
        is_tooltip_default={false}
        tooltip_default_text="{context.explanation_1}
        {context.explanation_2}
        {context.explanation_3}"
        width="410px" />



      <input
        id="pp_donate"
        type="submit"
        class="mdc-button mdc-button--unelevated margin-5"
        value={context.processing ? 'Processing...' : context.donate_label}
        disabled={!context.valid || context.processing || wait_api}
        on:click|preventDefault={async () => { await show_donation_intent() } } />

      <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>

      <img
        id="pp_donate_loader"
        src="/assets/spinners/orderer_loader.gif"
        alt="Loading"
        style="display: none" />
    </div>

    <div class="margin">
      <InputWithValidation
        id="donate-pp-amount"
        variant={'filled'}
        margin_bottom={'1px'}
        type="text"
        label={context.your_pp_label}
        name="pp-amount"
        bind:value={context.amount_text}
        width='100%' />
    </div>
  </div>



  <ConfirmDialog
    bind:show_confirm_flag={context.show_confirm}
    bind:confirmed_flag={context.confirmed}
    confirm_title={context.confirm_title}
    confirm_text={context.confirm_donation_text}
    confirm_no_label={context.confirm_no_label}
    confirm_yes_label={context.confirm_yes_label}
    confirm_yes_action={process_confirmed} />


</div>
<!-- end of fieldset Donate -->

<style>
    .required{
        font-size: 10pt;
        margin-bottom: 20px;
        color: #323232;
    }

  input::placeholder,
  textarea::placeholder {
    font-size: 0.8em;
    color: lightgrey;
  }

  #pp_donate:disabled {
    color: darkgrey;
  }

  #pp_donate:focus {
    outline: 0;
  }

  .hidden {
    display: none;
  }

  .total {
    color: dimgray;
    font-size: 90%;
    display: inline-block;
    margin-bottom: 1.5em;
  }

  .content {
    margin-bottom: 50px;
    margin-top: 60px;
    justify-content: center;
    display: flex;
  }

  .margin {
    margin-left: 10px;
  }
</style>
